import {translationManager} from "@/assets/plugins/mps-common/translation/translation-manager";
import MixinTranslation from "@/assets/plugins/mps-common/translation/MixinTranslation";
import MessageTranslation from "@/assets/plugins/mps-common/translation/MessageTranslation";

export default {

    install(Vue) {
        // 번역 관리자
        Vue.prototype.$translationManager = translationManager;
        Vue.mixin(MixinTranslation);
        Vue.mixin(MessageTranslation);
    }

}
